module.exports = __webpack_public_path__ + "f800c368b1926eda938fd67d31a55b3f.png";